// extracted by css-extract-rspack-plugin
module.exports =  {"news":"NewsCard-ViJZ__news","hide":"NewsCard-g3yD__hide","header-image":"NewsCard-YdaX__header-image","title":"NewsCard-zr2i__title"};